import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faTable, faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import Iframe from 'react-iframe'
import moment from 'moment';
import _ from "lodash";
import APIUrls from '../constants/ApiUrls';
import { APIManager } from "../utils/api";
import "./Analytics.scss";

const VIEW = {
  OVERVIEW: "overview",
  DATATABLE: "datatable",
  LEADERBOARD: "leaderboard"
};
class Analytics extends Component {
  constructor(props) {
    super(props);

    this.funnelData = Object.keys(_.get(props, 'settings.funnelStages', {})).map(key => ({ name: key, value: 10 }));

    this.state = {
      data: null,
      dataTable: null,
      period: 0,
      byDistributionType: 0,
      byContentAgeType: 0,
      tokens: null,
      // state for view
      viewSelected: VIEW.OVERVIEW,
      // viewOverview: true,
      // viewDatatable: false,
      // viewLeaderboard: false,
    };
  }

  async componentDidMount() {
    this.loadDataByPeriod();
    await this.refreshTokens();
  }

  getAxiosConfig = async () => {
    const tokens = await this.props.Auth.currentSession();

    const axiosConfig = {
      headers: {
        'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
        'X-Identity': tokens.idToken.jwtToken,
        "Content-Type": "application/json",
      },
      crossdomain: true
    };

    return axiosConfig;
  }

  refreshTokens = async () => {
    const functionName = "refreshTokens";
    const tokens = await this.props.Auth.currentSession();
    this.setState({tokens});
    console.log({functionName, tokens});
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // State handling

  onChangeView = (selectedView) => {
    // console.log(selectedView);
    switch (selectedView) {
      case VIEW.OVERVIEW:
        this.setState({viewSelected: VIEW.OVERVIEW});
        break;
      case VIEW.DATATABLE:
        this.setState({viewSelected: VIEW.DATATABLE});
        break;
      case VIEW.LEADERBOARD:
        this.setState({viewSelected: VIEW.LEADERBOARD});
        break;
    
      default:
        break;
    }
  }
  
  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Views


  renderOverview = () => {
    const tokens = this.state.tokens;
    if (tokens && tokens.accessToken) {
      const authToken = tokens.accessToken.jwtToken;
      const idToken = tokens.idToken.jwtToken
      const params = { 
        "ds34.authToken": authToken, 
        "ds34.idToken": idToken,
        "ds34.stage": process.env.REACT_APP_ENVIRONMENT
      }
      // console.log({functionName, params});
      const encodedParams = encodeURIComponent(JSON.stringify(params));
      const gdsUrl = `https://datastudio.google.com/embed/reporting/81ed4742-0c08-4c45-9120-759b3e68de81/page/buv6B?params=${encodedParams}`;
      return (
        <Iframe url={gdsUrl}
          width="800px"
          height="1500px"
          id="gdsOverview"
          className="performance-table-card"
          display="initial"
          position="relative"/>);
    }
  }

  renderDataTable = () => {
    const tokens = this.state.tokens;
    if (tokens && tokens.accessToken) {
      const authToken = tokens.accessToken.jwtToken;
      const idToken = tokens.idToken.jwtToken
      const params = { 
        "ds19.authToken": authToken, 
        "ds19.idToken": idToken, 
        "ds19.stage": process.env.REACT_APP_ENVIRONMENT
      }
      // console.log({functionName, params});
      const encodedParams = encodeURIComponent(JSON.stringify(params));
      const gdsUrl = `https://datastudio.google.com/embed/reporting/50ac7377-51d9-4309-a741-5ce9b4fc99fa/page/buv6B?params=${encodedParams}`;
      return (
        <Iframe url={gdsUrl}
          width="800px"
          height="1500px"
          id="gdsDatatable"
          className="performance-table-card"
          display="initial"
          position="relative"/>);
    }
  }

  renderLeaderboard = () => {
    const tokens = this.state.tokens;
    if (tokens && tokens.accessToken) {
      const authToken = tokens.accessToken.jwtToken;
      const idToken = tokens.idToken.jwtToken
      const params = { 
        "ds19.authToken": authToken, 
        "ds19.idToken": idToken, 
        "ds20.stage": process.env.REACT_APP_ENVIRONMENT
      }
      // console.log({functionName, params});
      const encodedParams = encodeURIComponent(JSON.stringify(params));
      const gdsUrl = `https://datastudio.google.com/embed/reporting/e5ff27f0-da89-450f-9120-a1c3cb52ad70/page/buv6B?params=${encodedParams}`;
      return (
        <Iframe url={gdsUrl}
          width="800px"
          height="1500px"
          id="gdsLeaderboard"
          className="performance-table-card"
          display="initial"
          position="relative"/>);
    }
  }

  loadDataByPeriod = async () => {
    let startDate = '';
    let endDate = '';

    switch (this.state.period) {
      case 0:
        startDate = moment().startOf('month').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
        break;
      case 1:
        startDate = moment().subtract(30, 'day').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
        break;
      case 2:
        startDate = moment().subtract(90, 'day').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
        break;
      default:
        break;
    }

    try {
      const axiosConfig = await this.getAxiosConfig();
      const data = await APIManager.Instance.call("GET", APIUrls.getAnalyticsDashboard(startDate, endDate), axiosConfig);
      this.setState({ data });
    } catch (e) {
    }
  }

  render() {

    return (
      <div className="analytics-main-view">
        <div className="left-sidebar">
          <FontAwesomeIcon icon={faTachometerAlt} onClick={ (e) => this.onChangeView(VIEW.OVERVIEW)} />
          <br/>
          <FontAwesomeIcon icon={faTable} onClick={ (e) => this.onChangeView(VIEW.DATATABLE)} />
          <br/>
          <FontAwesomeIcon icon={faUsers} onClick={ (e) => this.onChangeView(VIEW.LEADERBOARD)} />
        </div>
        <div className="analytics-page">
          {/* <h2 className="m-2">Analytics</h2> */}
          <div className="analytic-layout">
            
            <div className="details-container">
              
              { this.state.viewSelected === VIEW.OVERVIEW && this.renderOverview() }
              { this.state.viewSelected === VIEW.DATATABLE && this.renderDataTable() }
              { this.state.viewSelected === VIEW.LEADERBOARD && this.renderLeaderboard() }
              
            </div>
          </div>
        </div> 
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  Auth: state.auth.Auth
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);
